<app-form-area hiddenButtons>
  <app-input
    type="email"
    [label]="'PEOPLE_FORM.FORM.EMAIL.TITLE' | translate"
    [placeholder]="'PEOPLE_FORM.FORM.EMAIL.PLACEHOLDER' | translate"
    [control]="control().get('email')"
  />

  <div class="slide-toggle-container">
    <mat-slide-toggle
      labelPosition="before"
      [checked]="control().get('isMain')?.value"
      (change)="control().get('isMain')?.setValue($event.checked)"
      color="primary"
      [disabled]="disabled()"
    >
      {{ 'PEOPLE_FORM.FORM.EMAIL.MAIN_EMAIL' | translate }}
    </mat-slide-toggle>
  </div>
</app-form-area>
